export default __webpack_public_path__ + "5796174538802dd3c6c7e2d91b9bb5e2.svg";